import type { ReactElement } from "react";
import { KIT_METRICS, logical } from "./metrics.ts";

/**
 * A key glyph (brief section 5.1): a key's name in the pixel font on a light key cap, the `key` frame
 * painted on the button's insets. It names a shortcut and is never the only way to act (brief rule 23): the
 * action it names always has a button, a tap or a menu entry beside it. It takes no pointer events.
 *
 * @param props The key's name as the player reads it, such as `E` or `Esc`.
 * @returns The glyph.
 */
export function KeyGlyph({ children }: { readonly children: string }): ReactElement {
  return (
    <kbd className="ot-key ot-ui-frame-key" data-kit="key" style={{ height: logical(KIT_METRICS.key.height), paddingLeft: logical(KIT_METRICS.key.paddingX), paddingRight: logical(KIT_METRICS.key.paddingX) }}>
      {children}
    </kbd>
  );
}
